export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4751.c5e49ec8.jpg";